<div class="sidebar-wrapper p-3 mx-auto">
  <h4 class="">{{'BO_BOOKMARKS_TITLE' | translate}}</h4>
  @if (bookmarks$ | async; as bookmarks) {
    @if (bookmarks.length > 0) {
      @for (group of bookmarks; track group) {
        <div class="group-wrapper mt-3 mx-0">
          <div class="d-flex flex-row justify-content-between align-items-stretch">
            <h6 class="mx-0 my-auto mr-auto">{{ getGroupKey(group.key) }}</h6>
          </div>
          @if (group.members.length > 0) {
            <div>
              @for (bookmark of group.members; track bookmark) {
                <div class="d-flex flex-row align-items-stretch bookmark"
                  (click)="toggleSelection(bookmark)">
                  <a class="label m-0 pl-2 py-1 mr-auto" [routerLink]="" (click)="goto($event, bookmark)">
                    {{bookmark.label || bookmark.id}}
                  </a>
                  <a class="nav-link p-1" (click)="removeBookmark($event, bookmark)">
                    <i class="now-ui-icons ui-1_simple-remove text-danger"></i>
                  </a>
                </div>
              }
            </div>
          } @else {
            <p class="m-0 pl-3">{{ 'BO_NO_BOOKMARKS' | translate }}</p>
          }
        </div>
      }
    } @else {
      <p class="m-0 pl-3">{{ 'BO_NO_BOOKMARKS' | translate }}</p>
    }
  } @else {
    <span class="loading">
      <span class="dot">.</span>
      <span class="dot">.</span>
      <span class="dot">.</span>
    </span>
  }
  <!-- <ng-container *ngIf="oldBookmarks$ | async let oldBookmarks">
  <div class="mt-5">
    <h4 class="">{{'Unknown Client' | translate}}</h4>
    <div *ngFor="let group of oldBookmarks" class="group-wrapper mt-3 mx-0">
      <div class="d-flex flex-row justify-content-between align-items-stretch">
        <h6 class="mx-0 my-auto mr-auto">{{group.key}}</h6>
        <app-action-dropdown [actions]="oldFormActions" [actionItem]="group" actionClass="dropdown-right"></app-action-dropdown>
      </div>
      <ng-container *ngIf="group.members.length > 0 else nobookmarks">
        <div class="mt-2">
          <div *ngFor="let bookmark of group.members" class="d-flex flex-row align-items-stretch bookmark">
            <a class="label m-0 pl-2 py-1 mr-auto" [routerLink]="" (click)="goto($event, bookmark)">
              {{bookmark.label || bookmark.id}}
            </a>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container> -->
</div>


